<!--
 * @FileDescription: 售后订单详情
 * @Author: 陈文景
 * @Date: 2022-11-07 18:28:30
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div v-loading="loading" class="container">
    <div class="tips">
      <div class="refund-status">
        <div class="result">
          <span class="title">Review Information</span>
          <p class="time">
            <span>Review time: {{ defaultTips(formatTimeStamp(details.returnsDate)) }}</span>
            <span class="code">Review ID: {{ defaultTips(details.returnsId) }}</span>
          </p>
          <p class="process-info">
            <i :class="['circle', details.status === 0 ? 'info' : details.status === 1 ? 'warning' : details.status === 2 || details.status === 4 ? 'success' : details.status === 3 ? 'danger' : 'unknown']" />
            <span class="process">{{ ordersStatus(details.status) }}</span>
            <span class="reason">{{ defaultTips(details.refundReason) }}</span>
          </p>
          <div class="f--c">
            <span v-show="details.refundImage" style="margin-end:10px;">Customer upload image: </span>
            <div class="item pointer" v-for="(item, index) in details.refundImage" :key="`${item}${index}`">
              <div style="position: relative;">
                  <el-image :src="item" :preview-src-list="[item]"></el-image>
              </div>
            </div>
          </div>
          <p class="f--c time">
            <span>
              <el-tooltip v-if="details.reviewReason" class="item" effect="dark" :content="details.reviewReason" placement="top-start">
                <div slot="content" style="width:300px">{{ defaultTips(details.reviewReason) }}</div>
                <div class="ellipsis2">Review reason: {{ defaultTips(details.reviewReason) }}</div>
              </el-tooltip>
            </span>
          </p>
          <div class="f--c">
            <span v-show="details.reviewImage" style="margin-end:10px;">Review upload image: </span>
            <div class="item pointer" v-for="(item, index) in details.reviewImage" :key="`${item}${index}`">
              <div style="position: relative;">
                  <el-image :src="item" :preview-src-list="[item]"></el-image>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="refund-record">
        <el-button v-if="details.status === 1" href="javascript:;" class="process" @click="() => handleProcess(details.returnsId)">审核</el-button>
        <el-button :disabled="details.packItems && details.packItems.length ? false : true" round @click="showRefundRecord">退款记录</el-button>
      </div>
    </div>

    <div class="details">
      <div class="list">
        <template v-if="details.packItems && details.packItems.length">
          <div v-for="pack in details.packItems" :key="pack.omsPackId">
            <div class="header">
              <h3>Rufund Information</h3>
              <div class="order-info">
                <span class="order-code">Order ID: {{ defaultTips(pack.kkOrderId) }}</span>
                <span class="tracking-code">Parcel Code: {{ defaultTips(pack.omsPackId) }}</span>
                <span class="order-time">Payment Time: {{ defaultTips(formatTimeStamp(pack.payDate)) }}</span>
              </div>
            </div>
            <div>
              <SkuInfoItemTwo v-for="item in pack.items" :key="item.skuCode" :data="item" />
            </div>
          </div>
        </template>

        <template v-else>
          <div class="not-data">
            <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
            <div class="tips-text">No Record</div>
          </div>
        </template>
      </div>

      <div class="info">
        <div class="top">
          <div class="amount-info">
            <h3 class="title">Refunded Amount</h3>
            <p>
              <span>Subtotal</span>
              <span class="money">{{ `US $${amountTips(details.skusAmount)}` }}</span>
            </p>
            <p>
              <span>Shipping Fee</span>
              <span class="money">{{ `US $${amountTips(details.freightAmount)}` }}</span>
            </p>
            <p>
              <span>Promo code</span>
              <span class="money">{{ `- US $${amountTips(details.promotionAmount)}` }}</span>
            </p>
            <p>
              <span>Coupon</span>
              <span class="money">{{ `- US $${amountTips(details.couponTicketAmount)}` }}</span>
            </p>
          </div>
          <div class="refund-info">
            <span>Total</span>
            <span>{{ `- US $${amountTips(details.totalAmount)}` }}</span>
          </div>
        </div>
        <div class="button">
          <h3 class="title">Customer Info</h3>
          <div class="info">
            <p>
              <span>User Name</span>
              <span class="text">{{ defaultTips(details.userName) }}</span>
            </p>
            <p>
              <span>Email</span>
              <span class="text">{{ defaultTips(details.email) }}</span>
            </p>
            <p>
              <span>Phone Number</span>
              <span class="text">{{ defaultTips(details.phone) }}</span>
            </p>
            <p>
              <span>Register Time</span>
              <span class="text">{{ defaultTips(formatTimeStamp(details.registerDate)) }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 退款记录对话框 -->
    <RefundRecordDialog ref="refundRecordDialog" />
    <!-- 审核对话框 -->
    <ProcessDialog ref="processDialog" @update="getAfterSalesOrderDetails"/>
  </div>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/utils/moment'
import RefundRecordDialog from './RefundRecordDialog.vue'
import ProcessDialog from './ProcessDialog.vue'
import SkuInfoItemTwo from '@/components/SkuInfoItemTwo.vue'

export default {
  components: {
    SkuInfoItemTwo,
    RefundRecordDialog,
    ProcessDialog
  },
  data() {
    return {
      formatTimeStamp,

      loading: false,

      details: {} // 详情
    }
  },
  computed: {
    ordersStatus() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return '处理中'
          case 1:
            return '审核中'
          case 2:
            return '退款中'
          case 3:
            return '已拒绝'
          case 4:
            return '已完成'
          default:
            return '-'
        }
      }
    },
    amountTips() {
      return (value) => value || 0
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    this.getAfterSalesOrderDetails()
  },
  methods: {
    /**
     * API 获取售后订单详情
     */
    async getAfterSalesOrderDetails() {
      try {
        this.loading = true
        let { data } = await API.getAfterSalesOrderDetails(this.$route.query.returnsId)
        data.packItems = this.reformData(data.packItems || [])
        this.details = data
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    /**
     * 审核
     *
     * @param {Number} returnsId 当前行的订单ID
     */
     handleProcess(returnsId) {
      this.$refs.processDialog.show(returnsId)
    },
    /**
     * 改造未发货列表数据
     *
     * @param {Array} data 原数据
     * @returns {Array} 改造后的数据
     */
    reformData(data) {
      if (data.length) {
        data.forEach((outside) => {
          if (outside && outside.items && outside.items.length) {
            outside.items = outside.items.map((item) => ({
              ...item,
              options:
                JSON.parse(item.options) &&
                JSON.parse(item.options)
                  .map((option) => JSON.parse(option).value)
                  .join('、')
            }))
          }
        })
      }
      return data
    },

    /**
     * 显示退款记录对话框
     */
    showRefundRecord() {
      if (this.details.packItems && this.details.packItems.length) {
        this.$refs.refundRecordDialog.show(this.details.packItems[0].kkOrderId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1192px;
  margin: 0 auto;

  .tips {
    display: flex;
    min-height: 138px;
    padding: 14px 32px;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    .refund-status {
      flex: 1;
      position: relative;
      height: 100%;
      .result {
        height: 100%;
        color: #747a87;
        font-size: 14px;
        font-weight: 400;
        .title {
          color: #000;
          font-size: 18px;
          font-weight: 500;
        }
        .time {
          margin: 15px 0;
          .code {
            margin-left: 38px;
          }
        }
        .process-info {
          display: flex;
          align-items: center;
          margin-top: 5px;
          .circle {
            display: inline-block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            &.success {
              background-color: #99c41c;
            }
            &.warning {
              background-color: #e6a23c;
            }
            &.danger {
              background-color: #f56c6c;
            }
            &.info {
              background-color: #909399;
            }
            &.unknown {
              background-color: #f5f7f7;
            }
          }
          .process {
            margin-left: 6px;
          }
          .reason {
            margin-left: 38px;
          }
        }
      }
    }
    .refund-record {
      display: flex;
      flex-direction: column;
      .el-button {
        width: 120px;
        height: 40px;
        border-radius: 20px;
        margin: 5px;
      }
    }
  }
  .details {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    .list {
      width: 830px;
      padding: 15px 20px;
      background-color: #fff;
      .header {
        h3 {
          font-size: 18px;
          font-weight: 500;
        }
        .order-info {
          display: flex;
          color: #747a87;
          font-size: 14px;
          margin: 12px 0 18px;
          justify-content: space-between;
          .tracking-code {
            color: #99c41c;
          }
        }
      }
      .not-data {
        padding: 28px 0;
        height: 100%;
        text-align: center;
        .tips-text {
          color: #747a87;
          margin-top: 28px;
        }
      }
    }
    .info {
      width: 352px;
      .top {
        width: 100%;
        .amount-info {
          height: 215px;
          padding: 22px;
          background-color: #fff;
          border-bottom: 1px solid #f5f7f7;
          .title {
            font-size: 18px;
            font-weight: 500;
          }
          p {
            display: flex;
            color: #747a87;
            font-size: 14px;
            font-weight: 500;
            margin-top: 20px;
            justify-content: space-between;
            .money {
              color: #10141d;
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
        .refund-info {
          display: flex;
          color: #000;
          font-size: 18px;
          font-weight: 500;
          padding: 22px 12px;
          align-items: center;
          background-color: #fff;
          justify-content: space-between;
        }
      }
      .button {
        width: 100%;
        margin-top: 10px;
        padding: 12px;
        background-color: #fff;
        .title {
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 25px;
        }
        .info {
          width: 100%;
          color: #8b93a3;
          font-size: 14px;
          p {
            display: flex;
            padding: 8px 0;
            align-items: center;
            justify-content: space-between;
            &:first-child {
              padding-top: 0;
            }
            &:last-child {
              padding-bottom: 0;
            }
            .text {
              display: inline-block;
              max-width: 168px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
  .item{
    margin-right: 10px;

    .el-image{
        width: 70px;
        height: 72px;
        border-radius: 6px;
        border: 1px solid #CDD4DD;
    }
  }
}
</style>
